import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const SLIDERS = [["energy", "Energy"], ["hunger", "Hunger"], ["sleep", "Sleep quality"], ["stress", "Stress"],
  ["difficulty", "Training difficulty"], ["soreness", "Soreness"], ["motivation", "Motivation"], ["adherence", "Adherence %"], ["satisfaction", "Satisfaction"]];

export const CheckIn = ({ accessId, weekNumber, onClose, onDone }) => {
  const [f, setF] = useState({ week_number: weekNumber });
  const [review, setReview] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/programs/${accessId}/checkin`, f);
      setReview(data.review);
      toast.success("Check-in saved");
    } catch { toast.error("Check-in failed"); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass-strong border-white/10 max-w-lg max-h-[85vh] overflow-y-auto" data-testid="checkin-modal">
        <DialogHeader><DialogTitle className="font-serif text-2xl text-white">Weekly Check-in · Week {weekNumber}</DialogTitle></DialogHeader>
        {!review ? (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div><label className="text-[11px] text-slate-400">Weight (kg)</label><Input type="number" onChange={(e) => set("weight_kg", Number(e.target.value))} className="bg-black/40 border-white/10" data-testid="checkin-weight" /></div>
              <div><label className="text-[11px] text-slate-400">Waist (cm)</label><Input type="number" onChange={(e) => set("waist_cm", Number(e.target.value))} className="bg-black/40 border-white/10" data-testid="checkin-waist" /></div>
            </div>
            {SLIDERS.map(([k, l]) => (
              <div key={k}>
                <label className="text-[11px] text-slate-400 flex justify-between"><span>{l}</span><span className="font-mono text-cyan-300">{f[k] ?? 5}</span></label>
                <input type="range" min="1" max="10" value={f[k] ?? 5} onChange={(e) => set(k, Number(e.target.value))} className="w-full accent-cyan-400" data-testid={`checkin-${k}`} />
              </div>
            ))}
            <Textarea placeholder="Anything you want your coach to know?" onChange={(e) => set("comments", e.target.value)} className="bg-black/40 border-white/10" data-testid="checkin-comments" />
            <Button onClick={submit} disabled={busy} className="btn-primary rounded-lg w-full" data-testid="checkin-submit">{busy ? "Analyzing your week…" : "Submit check-in"}</Button>
          </div>
        ) : (
          <div className="space-y-4" data-testid="weekly-review">
            <div className="mono-label">Your weekly review · Chris Goss</div>
            {[["What went well", review.went_well], ["Where consistency dropped", review.dropped], ["Suggested improvements", review.improvements], ["Next week's focus", review.next_focus]].map(([t, v]) => v && (
              <div key={t}><div className="text-sm text-cyan-300">{t}</div><p className="text-[13px] text-slate-300 mt-1">{v}</p></div>
            ))}
            {review.suggested_adjustment?.type && review.suggested_adjustment.type !== "none" && (
              <div className="glass rounded-xl p-3"><div className="mono-label mb-1">Program update recommended</div><div className="text-[13px] text-slate-300">{review.suggested_adjustment.reason}</div></div>
            )}
            <Button onClick={onDone} className="btn-primary rounded-lg w-full" data-testid="review-continue">Continue to next week</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
